import * as THREE from 'three'
import OrbitControls from 'three-orbitcontrols'
import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader'
import {FBXLoader} from 'three/examples/jsm/loaders/FBXLoader'
import { Truck, Simulation, AdditionalCamPos, ControllBoxStep, CounterStep, CamposValue } from 'types/data'
import isDev from 'lib/isDev'
import smootRotate from 'lib/smoothRotation'
import SimulationController from './simulation'
// const GLTFLoader = require('three-gltf-loader')
import { RGBELoader } from './../../lib/rgbeloader'
import { Effect } from 'lib/sound'
import { truckFilter } from './filters'
import { ENVMAP, ENV_MODEL, GLTF } from 'constants/threeConstants'
import { SimulationType } from 'types/app'
import Remote from './remote'
import Raycaster from '../../lib/Raycaster'
import LeversPanel from './LeversPanel';
import getDomPosition from './getDomPosition';
import CameraTraveler from 'lib/cameratraveler/camera.traveler';
import { isMobile } from 'is-mobile';
import { REMOTE_TOGGLER } from 'constants/commonContsnts';
import { LEVERS_COMPLETE } from 'constants/sumilationConstants';
import ControllBox from './ControllBox'
import nativeAnimations from './nativeAnimations'
import FreestyleController from './Freestyle/Freestyle'
import FreestyleState from 'types/freestyle.types'
import { ThrowButtonEvent, incrementCounter } from 'actions/freestyle'
import cloneGltf from 'lib/cloneGltf'

interface ViewerProps {
  blurToggler: Function,
  node: HTMLDivElement,
  canvas: HTMLCanvasElement | null,
  setLaverPos: any,
  setEnginePower: Function,
  setPositionReady: Function,
  setAVSP: Function,
  onBoxPressEnd: Function,
  landingAudio: Effect,
  freestyleData: FreestyleState,
  setFreestyleApi: Function,
  setWaterTrackPositions: Function,
  onIncrement: (...args: Parameters<typeof incrementCounter>) => void
  onRemoteButtonClick: (...args: Parameters<typeof ThrowButtonEvent>) => void
}





const clock = new THREE.Clock()

class Viewer {
  protected props: ViewerProps
  protected envLoader: GLTFLoader 
  protected truckLoader: GLTFLoader  
  protected doorLoader: GLTFLoader  
  protected scene: THREE.Scene = new THREE.Scene()
  protected renderer: THREE.WebGLRenderer
  protected camera: THREE.PerspectiveCamera
  controls?: OrbitControls
  protected light?: THREE.DirectionalLight
  protected light2?: THREE.DirectionalLight
  protected truckManager: THREE.LoadingManager = new THREE.LoadingManager()
  protected envManager: THREE.LoadingManager = new THREE.LoadingManager()
  protected truck?: THREE.Scene | any
  protected env?: THREE.Group | any
  protected rotationEnable: Boolean = false
  protected freestyleModel!: GLTF
  protected sphere = THREE.Sphere.prototype
  freestyleVacuum: any

  isSimulation: Boolean = false
  isFreestyle: Boolean = false
  
  Simulations?: SimulationController
  protected pointer = new THREE.Vector2()
  protected animations?: THREE.AnimationClip[]
  protected rgbeLoader = new RGBELoader()
  protected envTexture?: any
  protected landingAudio?: Effect
  protected activeSimulationID?: any
  protected mixer?: THREE.AnimationMixer
  protected traveler?: CameraTraveler
  protected truckData!: Truck
  Freestyle!: FreestyleController
  protected activeLeversTimeout: any
  stopLandingAudioTimeout: any
  FBXLoader = new FBXLoader()
  protected counterSteps?: {
    data: CounterStep,
    cb: Function,
    currentStep: number,
  }
  protected activeStepsNativeAnimation: any
  
  ControlBox!: ControllBox
  protected remoteRaycasters?: {
    click: Function,
    move: Function,
    up: Function
  }
  protected boxRaycasters?: {
    click: Function,
    up: Function
  }
  protected rotationTarget: any
  protected rotationCamera: any

  directlyBlockCameraMoving = false
  isControlBox = false
  cameraMoving = false
  LeversControler = new LeversPanel()
  RemoteControler = new Remote()
  domPositionGetter: any
  isReverseLevers: Boolean = false
  endActiveSimulation?: Function
  isBlur: boolean = false
  setLoading: Function = () => {}
  loaded: Boolean
  hoseHelper?: THREE.SkeletonHelper
  freestyleDoor?: GLTF
  mouseHolded = false
  
  constructor(props: ViewerProps) {
    const { node, canvas } = props
    
    this.props = props
    this.loaded = false 
    this.landingAudio = this.props.landingAudio
    
    this.renderer = new THREE.WebGLRenderer({
      antialias: true,
      canvas: canvas!,
    })
    this.renderer.gammaInput = true
    this.renderer.gammaOutput = true

    node!.appendChild(this.renderer.domElement)

    this.renderer.setPixelRatio(window.devicePixelRatio)
    this.renderer.setSize(node!.offsetWidth, node!.offsetHeight)

    this.camera = new THREE.PerspectiveCamera(45, node!.offsetWidth / node!.offsetHeight, 1, 1000)
    this.camera.aspect = node!.offsetWidth / node!.offsetHeight
    this.camera.position.set(509.83418663664304,255.93153890294394, 853.7628945588749)
    this.camera.updateProjectionMatrix()
    this.camera.far = 150000

    this.scene.add(this.camera)
    this.domPositionGetter = getDomPosition(this.camera, props.node)
    
    window.addEventListener('resize', this.updateRendererSize)    
    
    this.envLoader = new GLTFLoader(this.envManager)
    this.truckLoader = new GLTFLoader(this.truckManager)
    this.doorLoader = new GLTFLoader()

    this.InitLight()
    this.initControls()
    this.initEvents()

    this.initMouseFakeCircle()
    this.render()

    //@ts-ignore
    window.viewer = this

    console.log(this)
  }

  checkRemoteHover = (e: any) => {
    if(!this.cameraMoving) {
      if(this.RemoteControler && this.isFreestyle && this.RemoteControler.model) {
        const isRemoteHovered =  Raycaster(this.pointer, this.camera, [this.RemoteControler.model! as THREE.Object3D])()
          || (e.target && e.target.dataset.type === 'hoverIssue')

          
          this.controls!.enabled = !isRemoteHovered
      }
    }
  }

  goToBasePosition = () => {
    this.camera.position.set(509.83418663664304,255.93153890294394, 853.7628945588749)
    this.controls!.target.set(0, 150, 0)

    this.Simulations!.resetAll()
    // this.rotationEnable = true
  }

  initMouseFakeCircle = () => {
    const geometry = new THREE.SphereGeometry( 5, 32, 32 );
    const material = new THREE.MeshBasicMaterial( {color: 0xffff00} );
    this.rotationTarget = new THREE.Mesh( geometry, material );
    const cameraposmat = material.clone()
    cameraposmat.color.set(0x00ff00)

    
    this.rotationCamera = new THREE.Mesh( geometry.clone(), cameraposmat );
    this.rotationCamera.visible = false
    this.rotationTarget.visible = false
    this.scene.add( this.rotationTarget );
    this.rotationTarget.add( this.rotationCamera );
  }

  protected setPointerCoordinates = (x: number, y: number) => {
    //@ts-ignore
    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    
    this.pointer.x = ( x / (iOS ? window.outerWidth : window.innerWidth) ) * 2 - 1 
    this.pointer.y = - ( y / (iOS ? window.outerHeight : window.innerHeight) ) * 2 + 1
  }

  setMouseHolded(h: boolean) {
    this.mouseHolded = h

    if(!h && this.isFreestyle) {
      this.updateFakeControlsPosition()
    } 
  }
  
  protected initEvents() {
    window.addEventListener('mousedown',  () =>  {
      if(!this.isSimulation && this.loaded) this.rotationEnable = false

      this.setMouseHolded(true)
    })
    window.addEventListener('mouseup', () =>  { 
      this.setMouseHolded(false)
      // if(!this.isSimulation && this.loaded) this.rotationEnable = true 
    })
    window.addEventListener('mousemove', (e) =>  {
      this.setPointerCoordinates(e.clientX, e.clientY)
      this.checkRemoteHover(e)
    })
    window.addEventListener('mouseup', (e) => {
      if(this.remoteRaycasters && this.boxRaycasters) {
        this.remoteRaycasters.up()
        this.boxRaycasters.up()
      }
    })
    window.addEventListener('mousedown', (e) => {
      if(this.remoteRaycasters && this.boxRaycasters) {
        this.remoteRaycasters.click()
        this.boxRaycasters.click()
      }
    })
    window.addEventListener('touchstart', (event) => {
      if(this.remoteRaycasters) {
        if(event.targetTouches[0]) {
          const touchE = event.targetTouches[0]
          this.setPointerCoordinates(touchE.clientX, touchE.clientY)
        }

        this.remoteRaycasters.click()
      }
    })
    window.addEventListener('touchend', (event) => {
      if(this.remoteRaycasters) {
        if(event.changedTouches[0]) {
          const touchE = event.changedTouches[0]
          this.setPointerCoordinates(touchE.clientX, touchE.clientY)
        }

        this.remoteRaycasters.up()
      }
    })
    window.addEventListener('mousemove', this.simulationMouseOrientation)
    window.addEventListener('deviceorientation', this.simulationMouseOrientation, true)
  }
  
  protected initControls() {
    this.controls = new OrbitControls(this.camera, this.props.node)
    
    if(!isDev) { 
      this.controls.enableZoom = false
      this.controls.enablePan = false
      this.controls.maxPolarAngle = 1.6150441064025907

      this.controls.minPolarAngle = 0
  
      this.controls.minDistance = 1000
      this.controls.autoRotateSpeed = -0.1
  
      this.controls.enableDamping = true
      this.controls.dampingFactor = 0.1
      this.controls.rotateSpeed = 0.08
    }
  }
  
  protected InitLight() {
    const { scene } = this
    
    this.light = new THREE.DirectionalLight(0xffffff, 1.5)
    this.light.position.set(717, 453, -833)
    scene.add(this.light)

    this.light2 = new THREE.DirectionalLight(0xffffff, 1.5)
    this.light2.position.set(-685, 405, 810)
    scene.add(this.light2)
    
    scene.add(new THREE.AmbientLight(0xffffff, .65))
  }
  
  protected setProgress(loaded: number, total: number) {
    this.setLoading({
      progress: loaded,
      max: total
    })
  }

  blurNode = async (blur?: Boolean, ratio?: number) => {
    const { blurToggler } = this.props

    await blurToggler(blur, ratio)
  }

  initLoading = async (truck: Truck, setLoading: Function, addLoadingProgress: Function): Promise<void> => {
    this.setLoading = setLoading
    
    
    const addInterval = setInterval(() => {
      if(this.loaded) {
        clearInterval(addInterval)
      } else {
        addLoadingProgress()
      }
    }, isDev ? 0 : 700)




    const remote = await this.RemoteControler.init(this.props.onRemoteButtonClick)
    this.camera.add(remote)
    
    const isButton = (item: any) => {
      return item.userData.button
    }

    this.remoteRaycasters = {
      click: Raycaster(this.pointer, this.camera, remote.children.filter(isButton), [this.RemoteControler.onClick]),
      move: Raycaster(this.pointer, this.camera, remote.children.filter(isButton), [this.RemoteControler.onMove]),
      up: Raycaster(this.pointer, this.camera, remote.children.filter(isButton), [this.RemoteControler.onUp]),
    }
    
    
    //@ts-ignore
    // this.landingAudio = new Effect('./simulations/sounds/sim92.ogg',  () => {}, true)
    this.env = await this.initEnv()
    
    this.truck = await this.initTruck(truck.model, truck)
    this.envTexture = await this.getEnvTexture()
    this.RemoteControler.setListeners([this.remoteUp], [this.remoteDown])
    
    await this.initFreestyleDoor()
    
    setLoading()

    return new Promise(resolve => {
      this.loaded = true
      setTimeout( () => {
        resolve()
        this.startLandingAudio()
        this.rotationEnable = true
      }, isDev ? 0 : 3500)

    })
  }

  remoteDown = (side: number) => {
    const sim = this.Simulations!.getSimById(this.activeSimulationID)
    const { greenButton } = sim.props.data.remote
    const reverse = sim.props.data.remote.reverse

    if(greenButton ? this.RemoteControler.greenPressed : !this.RemoteControler.greenPressed) {
      sim.animationForwards(reverse ? !side : !!side)
      if(sim.props.data.remote.endOnStop && (reverse ? !!side : !side))  this.onAnimationEnd()
    }
  }
  
  remoteUp = (side: number) => {
    const sim = this.Simulations!.getSimById(this.activeSimulationID)
    const { type, greenButton } = sim.props.data.remote
    const reverse = sim.props.data.remote.reverse

    if(type === REMOTE_TOGGLER) {

    } else if (greenButton ? this.RemoteControler.greenPressed : !this.RemoteControler.greenPressed) { 
      sim.animationForwardsStop(reverse ? !side : !!side)

    }
  }

  startLandingAudio = () => {
    console.log(this.landingAudio!.playing)
    
    if(this.landingAudio!.playing) {
      this.landingAudio!.unmute()
    } else {
      this.landingAudio!.play()
    }

    this.controls!.enabled = true
    this.camera.userData.simPos = null
  }

  stopLandingAudio = () => {
    if(this.landingAudio) {
      this.landingAudio.mute()
    }
  }

  initSimLoading = () => {
    return new Promise(resolve => setTimeout(resolve, 100))
  }

  initSimulation = async (simulation: Simulation, onInit: Function = ()=>{}) => {
    const { controls } = this
    
    this.RemoteControler.allowGreenPress = true
    this.cameraMoving = true
    this.rotationEnable = false
    this.resetNativeAnimation()
    this.isSimulation = true
    controls!.enabled = isDev || false
    controls!.minDistance = 0
  
    this.activeSimulationID = simulation.id
    this.Simulations!.resetAll()

    truckFilter(this.truck, this.truckData)

    await this.Simulations!.startSimulation(simulation.id)
    this.updateFakeControlsPosition()
    this.cameraMoving = false
    onInit()
  }

  setDirectCamPos = async (campos: AdditionalCamPos, timeout: number) => {
    return new Promise(resolve => {
      if(this.Simulations) {
        this.cameraMoving = true
        setTimeout(async () => {
          await this.Simulations!.activeGoTo({id: this.activeSimulationID, directPosition: campos})
          this.cameraMoving = false
          
          this.updateFakeControlsPosition()
          resolve()
        }, isDev ? 10 : timeout)
      } 
    })
  }


  initFreestyle = async () => {
    this.setFreestyle(true)
    this.controls!.enabled = isDev || false
    this.controls!.enableDamping = false
    this.controls!.rotateSpeed = 1


    this.RemoteControler!.initFreestyle()
  }

  stopFreestyle = () => {
    this.RemoteControler!.stopFreestyle()
    this.Freestyle.dispose()

    
    this.setFreestyle(false)

    this.goToBasePosition()

    this.controls!.enabled = true

  }
  
  goToPosition = async(campos: CamposValue) => {
    this.sphere = new THREE.Box3().expandByObject(this.truck).getBoundingSphere(new THREE.Sphere())
    this.cameraMoving = true

    await this.traveler!.travelAroundBoundingSphere({
      start: {
        camera: this.camera.position.toArray(),
        controls: this.controls!.target.toArray(),
        crossPoints: {
          out: [],
          in: []
        }
      },
      end: {
        camera: campos.camera,
        controls: campos.controls,
      }
    }, this.sphere, 40)

    
    this.cameraMoving = false
  }
  
  setFreestyle(x: boolean) {
    this.RemoteControler.isFreestyle = x
    this.isFreestyle = x  
    
    if(this.freestyleModel) {
      this.freestyleModel!.scene.visible = x
    }

    if(this.freestyleDoor) {
      this.freestyleDoor!.scene.visible = x
    }

    this.scene.traverse(item => {
      if(this.truckData.hidden_freestyle.includes(item.name)) {
        item.visible = !x
      }
    })

    this.scene.traverse(item => {
      if(this.truckData.shown_freestyle.includes(item.name)) {
        item.visible = x
      }
    })    
  }
  
  toggleSimulationTypePosition = async (type: SimulationType, concatPos?: AdditionalCamPos) => {
    if(this.Simulations) {
      this.cameraMoving = true      
      
      await this.Simulations!.activeGoTo({id: this.activeSimulationID, type, concatPos})
      this.cameraMoving = false

      this.updateFakeControlsPosition()      
    }
  }

  updateFakeControlsPosition = () => {
    this.rotationTarget.position.copy(this.controls!.target.clone())
    this.rotationCamera.position.copy(this.camera.position.clone().sub(this.rotationTarget.position))
    this.rotationTarget.rotation.set(0, 0, 0)
  }
  
  setSimulations = (simulations: Simulation[]) => {
    const { camera, controls } = this
    const { setPositionReady, setEnginePower } = this.props
    this.traveler = new CameraTraveler({camera, controls})
    
    this.Simulations = new SimulationController({
      truck: this.truck,
      setPositionReady,
      setEnginePower,
      onNativeSimEnd: this.onAnimationEnd,
      camera,
      simulations,
      controls: controls!,
      animations: this.animations,
      mixer: this.mixer!,
      traveler: this.traveler
    })
  }

  protected simulationMouseOrientation = (event: any) => {
    const { camera } = this
    const rotationMultiplyZ = 0.05
    const rotationMultiplyY = 0.05
    
    if((this.isSimulation || (this.isFreestyle)) && !this.mouseHolded && !this.isControlBox && camera && !isMobile() && !isDev && !this.cameraMoving && !this.directlyBlockCameraMoving) {
      const { x: mx, y: my } = this.pointer 

      this.rotationTarget.rotation.set(
        0,
        +(mx * rotationMultiplyY),
        -(my * rotationMultiplyZ),
      )
      
      this.rotationTarget.updateMatrixWorld()
      
      this.camera.position.setFromMatrixPosition(this.rotationCamera.matrixWorld)
      this.controls!.update()
    }
  }

  

  resetControlBox = (holdCounter?: Boolean) => {
    this.isControlBox = false
    
    // setTimeout(() => {
      this.ControlBox.reset()
    // }, 6000);

    const counterSim = this.Simulations!.getSimById(this.activeSimulationID)
    if(counterSim && counterSim.counter && !holdCounter) {
      counterSim.reset()
    }
  }

  onBoxPressed = ({event, switchType, step} : {event: THREE.Event, step?: ControllBoxStep, switchType?: string}) => {

    if(step && step.type === 'switch') {
      const activeSim = this.Simulations!.getSimById(this.activeSimulationID)

      activeSim!.animationForwards(switchType === 'bottom' ? false : true)
    }  else  {
      this.props.onBoxPressEnd()

    }
  }
  
  freestyleMaps: any = {}
  protected initFreestyleModel = () => {
    return new Promise((resolve, reject) => {
      this.truckLoader.load(this.truckData.freestyle_model, data => {

        this.FBXLoader.load('./models/f4/hose_pipa.fbx', async (hose_end) => {

          // const map: THREE.Texture = await new Promise(r => new THREE.TextureLoader().load('./uv_checkerlarge.png', r, undefined, console.error))

          // map.repeat.set(4, .4)
          // map.wrapS = THREE.RepeatWrapping;
          // map.wrapT = THREE.RepeatWrapping;
          
          const normalMap: THREE.Texture = await new Promise(r => new THREE.TextureLoader().load('./hose_normal.jpg', r, undefined, console.log))

          normalMap.repeat.set(18, .8)
          normalMap.wrapS = THREE.RepeatWrapping;
          normalMap.wrapT = THREE.RepeatWrapping;

          this.freestyleMaps = { normalMap}
          
          this.freestyleModel = data
          this.scene.add(this.freestyleModel.scene)
          this.freestyleModel.scene.visible = false
          
          const hose = data.scene.getObjectByName('Truck013')!
          const hose_child = hose_end.children[0]! 
          hose_child.name = 'hose_end'
          data.scene.add(hose_child)
          this.scene.attach(hose)
          hose.visible = false
          
          const v = this.scene.getObjectByName('Vacuum')!
          const vacuum = v.clone()
          //@ts-ignore
          vacuum.geometry = v.geometry.clone()
          //@ts-ignore
          vacuum.material = v.material.clone()
          //@ts-ignore
          vacuum.material.side = THREE.DoubleSide
          //@ts-ignore
          const lastBone: any = hose.skeleton.bones[hose.skeleton.bones.length - 1] 
          vacuum.name = 'FreestyleVacuum'
          hose_child.add(vacuum)
          vacuum.visible = true
          vacuum.rotation.set(0,-Math.PI / 2,Math.PI / 2)
          vacuum.position.set(0, 0, 35)

          this.freestyleVacuum = vacuum
          
          
          
          resolve()
        }, undefined, console.error)
      }, undefined, console.error)

      // resolve()
    })
  }

  protected initFreestyleDoor = () => {
    return new Promise((resolve, reject) => {
    //   this.truckLoader.load(BOOM_FREESTYLE_URL, data => {
    //     this.freestyleDoor = data
    //     this.scene.add(this.freestyleDoor.scene)
    //     data.scene.visible = false
        
    //     resolve()
    //   }, undefined, reject)
      resolve()
    })
  }
  
  protected initTruck = async (url: string, modelData: Truck) => {

    return new Promise((resolve, reject) => {
      this.truckLoader.load(url, async (data) => {
        
        this.animations = data.animations
        this.scene.add(data.scene)
        
        this.mixer = new THREE.AnimationMixer(data.scene)

        this.mixer.addEventListener('finished', (e) => {
          if(e.direction !== -1) {
            this.onAnimationEnd()
          } else {
            this.onAnimationOnStart()
          }
        })
        
        this.ControlBox = new ControllBox({
          truck: data.scene,
          truckData: modelData,
          truckAnimations: this.animations,
          onAnimationEnd: this.onBoxPressed,
          bindDom: (mesh: THREE.Mesh) => this.domPositionGetter.bindPos(mesh, this.props.setWaterTrackPositions),
          bindRaycaster: ({onDown, onUp, meshes}: {onDown: Function, onUp: Function, meshes: THREE.Object3D[]}) => {
            this.boxRaycasters = {
              click: Raycaster(this.pointer, this.camera, meshes, [onDown]),
              up: Raycaster(this.pointer, this.camera, meshes, [onUp]),
            }
          }
        })
        
        this.LeversControler.init({
          animations: this.animations.filter(item => item.name.includes('Lever')),
          truck: data.scene,
          onFinish: this.onLeversEnd,
          bindDom: (mesh: THREE.Mesh) => this.domPositionGetter.bindPos(mesh, this.props.setLaverPos),
          models: {
            levers: data.scene.children.filter((item: any) => item.name.includes('Lever')),
            labels: data.scene.children.filter((item: any) => item.name.includes('Label')),
            panel: data.scene.children.filter((item: any) => item.name.includes('ValveBank')),
          }
        })
        
        this.truckData = modelData
        truckFilter(data.scene, modelData)
        
        this.controls!.target.y = 150

        await this.initFreestyleModel()
        await this.initFreestyleDoor()

        this.Freestyle = new FreestyleController({
          truck: data,
          data: this.props.freestyleData,
          freestyleModels: [...(this.freestyleModel ? [this.freestyleModel] : []), ...(this.freestyleDoor ? [this.freestyleDoor] : [])],
          freestyleModel: this.freestyleModel || this.freestyleDoor,
          viewerApi: this,
          maps: this.freestyleMaps,
          onIncrement: this.props.onIncrement
        })

        this.props.setFreestyleApi(this.Freestyle)
        
        resolve(data.scene)
      })
    })
  }

  onAnimationOnStart() {
    const sim = this.Simulations!.getSimById(this.activeSimulationID)
    sim.animationForwardsStop(false)
  }
  
  onAnimationEnd = () => {
    const sim = this.Simulations!.getSimById(this.activeSimulationID)
    sim.animationForwardsStop(false)

    this.endActiveSimulation!()
    this.props.setAVSP(false)
  }
  
  onLeversEnd = async () => {
    const sim = this.Simulations!.getSimById(this.activeSimulationID)

    if(sim.props.data.noAVPS) {
      this.onAnimationEnd()
    } else {
      this.props.setPositionReady(false)
      this.cameraMoving = true
      await this.Simulations!.activeGoTo({type: LEVERS_COMPLETE, id: this.activeSimulationID})
      this.updateFakeControlsPosition()
      this.props.setAVSP(true)
      sim.animationForwards(true)
      setTimeout(() => {
        this.cameraMoving = false
      }, 100);
    }
  }

  updateCurrentCounterSteps = (counterStep: CounterStep, cb: Function ) => {
    this.counterSteps = {
      data: counterStep,
      currentStep: 0,
      cb
    }

    this.nextCurrentCounterStep(false)
  }
  
  onCounterStepClicked = () => {
    const { currentStep, data, cb } = this.counterSteps!
    
    if(currentStep !== data.steps.length - 1) {
      this.counterSteps!.currentStep += 1
      this.nextCurrentCounterStep(true)
    } else {
      cb()
    }

    const targetStep = this.counterSteps!.data.steps[currentStep]
    if(targetStep.nativeAnimation) {
      const { name, meshName } = targetStep.nativeAnimation
      this.activeStepsNativeAnimation = nativeAnimations(name)(this.truck.getObjectByName(meshName), () => {})
      this.activeStepsNativeAnimation.setPause(false)
    }

    if(targetStep.sound) {
      const activeSim = this.Simulations!.getSimById(this.activeSimulationID)
      const targetSound = activeSim.soundEffects.find(item => item.src === targetStep.sound)

      activeSim.soundEffects.forEach(item => item.stop(true))
      targetSound!.play()
      targetSound!.setLoop(true)
    }

    if(targetStep.stopAnimations) {
      this.resetNativeAnimation()
    }

  }

  resetSimulations() {
    this.Simulations!.resetAll()

    this.scene.traverse(item => {
      if(this.truckData.hidden_meshes!.includes(item.name)) {
        item.visible = false
      }
    })
  }

  resetNativeAnimation = () => {
    if(this.activeSimulationID && this.Simulations) {
      const activeSim = this.Simulations!.getSimById(this.activeSimulationID)
      if(activeSim) {
        activeSim.soundEffects.forEach(item => item.stop(true))
      }
    }
    
    if(this.activeStepsNativeAnimation) {
      this.activeStepsNativeAnimation.setPause(true)
      setTimeout(() => {
        this.activeStepsNativeAnimation = null
      }, 400)
    }
  }

  nextCurrentCounterStep = (next: boolean) => {
    const currentStep = this.counterSteps!.data.steps[this.counterSteps!.currentStep]
    
    if(currentStep.target.type === 'remote') {
      if(currentStep.target.target === 'greenButton') {
        this.RemoteControler.allowGreenPress = true
        this.RemoteControler.onFirstGreenButtonClick = () => {
          this.onCounterStepClicked()
          this.RemoteControler.allowGreenPress = false
        }
        this.RemoteControler.setActiveLights([], () => {})
      } else {
        this.RemoteControler.allowGreenPress = false
        this.RemoteControler.setActiveLights([currentStep.target.target], this.onCounterStepClicked)
        
      }
    }
  }
  
  protected getEnvTexture = async () => {
    const textureCube = new THREE.CubeTextureLoader().load(ENVMAP)
    textureCube.format = THREE.RGBFormat
    textureCube.mapping = THREE.CubeReflectionMapping
    textureCube.encoding = THREE.sRGBEncoding

    this.truck!.traverse((item: any) => {
      if(item.material) {
        item.material.envMap = textureCube
        item.material.envMapIntensity = 3

        if(item.name === 'Flow') {
          item.material.map = null
          item.material.alphaMap = new THREE.TextureLoader().load('./environment/shadow/al.jpg')
          item.material.transparent = true
          item.material.needsUpdate = true
        }
        
        if (item.material.map && !item.material.textureUpdate) {
          item.material.textureUpdate = true
        }

       item.material.needsUpdate = true
      }
    })
  }
  
  protected initEnv = async () => {    
    return new Promise((resolve, reject) => {      
      this.envLoader.load(ENV_MODEL, (data: any) => {
        this.scene.add(data.scene)
        data.scene.scale.set(.9, .9, .9)
        data.scene.position.y = 23

        data.scene.traverse((item: any) => {
          if(item.material) {

            item.material.metalness = 0 
            item.material.needsUpdate = true
          }
        })
        
        resolve(data.scene)
      })
    })
  }
  
  
  protected updateRendererSize = () => {
    const { renderer, camera } = this
    const { node } = this.props

    renderer.setSize(node!.offsetWidth, node!.offsetHeight)

    camera.aspect = node!.offsetWidth / node!.offsetHeight
    camera.updateProjectionMatrix()
  }

  protected cameraRotation = () => true && this.rotationEnable && smootRotate(this.camera, this.controls!)

  protected render = () => {
    const { scene, camera } = this
    const { offsetWidth, offsetHeight } = this.props.node
    const delta = clock.getDelta()

    this.renderer.render(scene, camera)
    this.cameraRotation()
    
    this.updateRendererSize()
    this.controls!.update() 
    if(this.traveler) this.traveler.animate()
    if(this.mixer) this.mixer.update(delta)
    if(this.ControlBox) this.ControlBox.update(delta)
    if(this.RemoteControler.mixer) this.RemoteControler.mixer.update(delta)
    if(this.RemoteControler) this.RemoteControler.updatePosition(offsetWidth, offsetHeight)
    if(this.domPositionGetter) this.domPositionGetter.update(this.isReverseLevers)
    if(this.Freestyle) this.Freestyle.update(delta)
    // if(this.hoseHelper) this.hoseHelper.update(delta)

    if(this.activeStepsNativeAnimation) {
      this.activeStepsNativeAnimation.update()
    } else if(this.Simulations) {
      this.Simulations.update(this.activeSimulationID)
    }
    requestAnimationFrame(this.render)
  }
}

export default Viewer